import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CustomPartCategoriesPage } from '@/areas/settings/Settings/CustomPartCategoriesPage/CustomPartCategoriesPage';
import { canViewGeneralSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/custom-part-categories')({
    staticData: {
        access: { permissions: canViewGeneralSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CustomPartCategoriesPage />;
}
